import React, { ChangeEvent } from 'react';
import { useTranslation } from 'react-i18next';
import clsx from 'clsx';
import styles from '../PasswordProtectionUnlock.module.scss';
import { TranslationKey } from '@/types/i18n.types';

interface IUnlockFormProps {
  readonly inputValue: string;
  readonly inputType: 'password' | 'text';
  readonly placeholder: TranslationKey | '';
  readonly inputError: boolean;
  readonly errorText: TranslationKey;
  readonly showForgotPassword: boolean;
  readonly onInputChange: (e: ChangeEvent<HTMLInputElement>) => void;
  readonly onKeyDown: (e: React.KeyboardEvent<HTMLInputElement>) => void;
  readonly onForgotPasswordClick: () => void;
}

export const UnlockForm: React.FC<IUnlockFormProps> = ({
  inputValue,
  inputType,
  placeholder,
  inputError,
  errorText,
  showForgotPassword,
  onInputChange,
  onKeyDown,
  onForgotPasswordClick,
}) => {
  const { t } = useTranslation();

  return (
    <div className={styles.unlockFormWrapper}>
      <input
        className={clsx(styles.unlockPasswordInput, inputError && styles.error)}
        placeholder={placeholder ? t(placeholder) : ''}
        type={inputType}
        value={inputValue}
        onChange={onInputChange}
        onKeyDown={onKeyDown}
        autoComplete={inputType === 'password' ? 'current-password' : 'off'}
        autoFocus
      />
      {inputError && (
        <div className={styles.unlockPasswordError}>{t(errorText)}</div>
      )}
      {showForgotPassword && (
        <button
          type="button"
          className={styles.forgotPasswordBtn}
          onClick={onForgotPasswordClick}
        >
          {t('blockPage.unlock.forgotPassword')}
        </button>
      )}
    </div>
  );
};
